import React from "react";
import ConvertDataService from "../../../../services/util/ConvertDatas";
import { Table } from 'react-bootstrap';

const PercentuaisFinanceirosTabelaHistorico = ({ dataHistory }) => {
    function capitalizeFirstLetter(str) {
        if (!str) return "";
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    return (
        <div>
            {
                dataHistory.message ? <h5>{dataHistory.message}</h5> :
            
            <Table striped bordered hover>
                <thead>
                        <tr>
                            <th>Última atualização</th>
                            <th>Modificado por</th>
                            <th>Informação alterada</th>
                            <th>Valor anterior</th>
                            <th>Valor novo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataHistory.map((item, index) => (
                            <tr key={index}>
                                <td>{ConvertDataService.convertDataToDDmmExtenseYYYY(item.data_atualizacao, true)}</td>
                                <td>{item.origem_atualizacao}</td>
                                <td>{item.informacao_atualizada}</td>
                                <td>{item.dados_antigos}</td>
                                <td>{item.dados_novos}</td>
                            </tr>
                        ))
                        }
                    </tbody>
            </Table>
            }
        </div>
    );
}

export default PercentuaisFinanceirosTabelaHistorico;